var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 218.661,
    height: 62.968,
    viewBox: "0 0 218.661 62.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 218.661,
    height: 62.968,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M61.764,44.5A3.28,3.28,0,0,0,61,46.79V83.053a3.274,3.274,0,0,0,.764,2.316l.123.123,20.3-20.3v-.468L61.887,44.4Z",
    transform: "translate(-61 -44.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.082,
    y1: 1.214,
    x2: -0.076,
    y2: 1.214,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M147,106.075v.468l6.775,6.775.148-.1,8.031-4.533c2.291-1.306,2.291-3.424,0-4.73L153.922,99.4l-.148-.1Z",
    transform: "translate(-147 -99.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.1,
    y1: 2.747,
    x2: -2.086,
    y2: 2.747,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M64.1,148.147c.764.788,2,.887,3.4.1l23.945-13.623L84.522,127.7Z",
    transform: "translate(-64.1 -127.7)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.356,
    y1: 1.106,
    x2: -0.349,
    y2: 1.106,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M64.1,42.834,84.522,63.256l6.922-6.9L67.5,42.735a3.81,3.81,0,0,0-1.84-.544,2.076,2.076,0,0,0-1.56.643",
    transform: "translate(-64.1 -42.191)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.361,
    y1: 1.729,
    x2: -0.354,
    y2: 1.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 27.345,
    height: 14.329,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 0.887,
    height: 2.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 9.903,
    height: 6.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 37.864,
    height: 21.075,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M8,1.5H212.918a6.512,6.512,0,0,1,6.5,6.528V57.2a6.548,6.548,0,0,1-6.528,6.528H8A6.527,6.527,0,0,1,1.5,57.2V8.028A6.512,6.512,0,0,1,8,1.5",
    transform: "translate(-1.13 -1.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M8,1.5H212.918a6.512,6.512,0,0,1,6.5,6.528V57.2a6.548,6.548,0,0,1-6.528,6.528H8A6.527,6.527,0,0,1,1.5,57.2V8.028A6.512,6.512,0,0,1,8,1.5Z",
    transform: "translate(-1.13 -1.13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M279.75,45.843a4.422,4.422,0,0,1-1.232,3.277,4.843,4.843,0,0,1-3.621,1.453,5.047,5.047,0,0,1-5.1-5.026v-.123a5.031,5.031,0,0,1,5-5.124h.123a5.2,5.2,0,0,1,2.02.419,4.006,4.006,0,0,1,1.527,1.109l-.862.862a3.3,3.3,0,0,0-2.685-1.158,3.8,3.8,0,0,0-3.818,3.794v.148a3.8,3.8,0,0,0,3.646,3.942h.172a3.66,3.66,0,0,0,2.734-1.109,3.309,3.309,0,0,0,.838-2h-3.572V45.129H279.7a6.487,6.487,0,0,1,.049.714",
    transform: "translate(-203.332 -30.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M279.75,45.843a4.422,4.422,0,0,1-1.232,3.277,4.843,4.843,0,0,1-3.621,1.453,5.047,5.047,0,0,1-5.1-5.026v-.123a5.031,5.031,0,0,1,5-5.124h.123a5.2,5.2,0,0,1,2.02.419,4.006,4.006,0,0,1,1.527,1.109l-.862.862a3.3,3.3,0,0,0-2.685-1.158,3.8,3.8,0,0,0-3.818,3.794v.148a3.8,3.8,0,0,0,3.646,3.942h.172a3.66,3.66,0,0,0,2.734-1.109,3.309,3.309,0,0,0,.838-2h-3.572V45.129H279.7A6.487,6.487,0,0,1,279.75,45.843Z",
    transform: "translate(-203.332 -30.372)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M323.34,42.507h-4.484v3.129h4.04v1.182h-4.04v3.129h4.484v1.207H317.6V41.3h5.74Z",
    transform: "translate(-239.359 -31.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M323.34,42.507h-4.484v3.129h4.04v1.182h-4.04v3.129h4.484v1.207H317.6V41.3h5.74Z",
    transform: "translate(-239.359 -31.126)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M350.216,51.13h-1.256V42.507H346.2V41.3h6.75v1.207h-2.759V51.13Z",
    transform: "translate(-260.913 -31.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M350.216,51.13h-1.256V42.507H346.2V41.3h6.75v1.207h-2.759V51.13Z",
    transform: "translate(-260.913 -31.126)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 1.256,
    height: 9.83,
    transform: "translate(96.939 10.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 1.256,
    height: 9.83,
    transform: "translate(96.939 10.174)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M409.191,51.13h-1.256V42.507H405.2V41.3h6.75v1.207h-2.734V51.13Z",
    transform: "translate(-305.379 -31.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M409.191,51.13h-1.256V42.507H405.2V41.3h6.75v1.207h-2.734V51.13Z",
    transform: "translate(-305.379 -31.126)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M457.969,49.114a5.1,5.1,0,0,1-7.218,0,5.122,5.122,0,1,1,8.647-3.646,4.918,4.918,0,0,1-1.429,3.646m-6.307-.813a3.761,3.761,0,0,0,6.43-2.833,3.9,3.9,0,0,0-1.084-2.808,3.76,3.76,0,0,0-6.43,2.808,4,4,0,0,0,1.084,2.833",
    transform: "translate(-338.612 -30.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M457.969,49.114a5.1,5.1,0,0,1-7.218,0,5.122,5.122,0,1,1,8.647-3.646A4.918,4.918,0,0,1,457.969,49.114Zm-6.307-.813a3.761,3.761,0,0,0,6.43-2.833,3.9,3.9,0,0,0-1.084-2.808,3.76,3.76,0,0,0-6.43,2.808A4,4,0,0,0,451.662,48.3Z",
    transform: "translate(-338.612 -30.391)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M497.5,51.13V41.3h1.527l4.779,7.662h.049l-.049-1.9V41.3h1.256v9.83h-1.33l-5-8.031h-.049l.049,1.9V51.13Z",
    transform: "translate(-374.941 -31.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M497.5,51.13V41.3h1.527l4.779,7.662h.049l-.049-1.9V41.3h1.256v9.83h-1.33l-5-8.031h-.049l.049,1.9V51.13Z",
    transform: "translate(-374.941 -31.126)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M312.192,115.881a6.972,6.972,0,1,0,7,6.972,6.878,6.878,0,0,0-7-6.972m0,11.209a4.222,4.222,0,1,1,3.942-4.213,4.035,4.035,0,0,1-3.942,4.213m-15.274-11.209a6.972,6.972,0,1,0,7,6.972,6.878,6.878,0,0,0-7-6.972m0,11.209a4.222,4.222,0,1,1,3.942-4.213,4.035,4.035,0,0,1-3.942,4.213m-18.156-9.066v2.956h7.07a6.134,6.134,0,0,1-1.6,3.72,7.23,7.23,0,0,1-5.469,2.168,7.859,7.859,0,0,1,0-15.717,7.563,7.563,0,0,1,5.346,2.119l2.094-2.094a10.325,10.325,0,0,0-7.415-2.981,10.828,10.828,0,1,0,0,21.655,9.975,9.975,0,0,0,7.563-3.03,9.807,9.807,0,0,0,2.562-6.923,11.666,11.666,0,0,0-.148-1.848Zm74.275,2.291a6.456,6.456,0,0,0-5.962-4.434c-3.621,0-6.553,2.833-6.553,6.972a6.817,6.817,0,0,0,6.922,6.972,6.959,6.959,0,0,0,5.814-3.079l-2.39-1.577a3.973,3.973,0,0,1-3.424,1.922,3.544,3.544,0,0,1-3.375-2.119l9.312-3.843Zm-9.509,2.316a3.836,3.836,0,0,1,3.646-4.065,2.722,2.722,0,0,1,2.587,1.478Zm-7.563,6.775h3.079v-20.5h-3.079Zm-5.026-11.973h-.1a4.834,4.834,0,0,0-3.671-1.552,6.978,6.978,0,0,0,0,13.944,4.761,4.761,0,0,0,3.671-1.577h.1v1.01c0,2.661-1.429,4.089-3.72,4.089a3.9,3.9,0,0,1-3.523-2.488l-2.661,1.109a6.617,6.617,0,0,0,6.183,4.114c3.6,0,6.627-2.119,6.627-7.267V116.3H330.94Zm-3.523,9.632a4.239,4.239,0,0,1,0-8.45c2.119,0,3.72,1.8,3.72,4.262s-1.626,4.188-3.72,4.188M367.4,108.909h-7.341v20.5h3.055v-7.736h4.262a6.389,6.389,0,1,0,.025-12.761m.074,9.879h-4.36v-7.021h4.36a3.512,3.512,0,0,1,.172,7.021Zm18.9-2.956a5.792,5.792,0,0,0-5.469,3.129l2.71,1.133a2.893,2.893,0,0,1,2.784-1.5c1.577,0,3.178.961,3.2,2.636v.222a6.918,6.918,0,0,0-3.2-.788c-2.931,0-5.912,1.6-5.912,4.607,0,2.735,2.39,4.508,5.1,4.508a4.355,4.355,0,0,0,3.892-2h.1v1.577h2.956v-7.834c.074-3.646-2.661-5.666-6.159-5.691M386,127.066c-1.01,0-2.39-.493-2.39-1.749,0-1.577,1.749-2.193,3.252-2.193a5.432,5.432,0,0,1,2.784.69A3.694,3.694,0,0,1,386,127.066M403.342,116.3l-3.5,8.893h-.1L396.1,116.3h-3.3l5.469,12.416-3.1,6.9h3.2l8.4-19.314ZM375.8,129.406h3.055v-20.5H375.8Z",
    transform: "translate(-201.827 -81.54)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(15.027 10.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 44.037,
    height: 44.037,
    transform: "translate(-20.546 20.546) rotate(-45)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(36.214 24.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 17.245,
    height: 14.018,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(15.791 31.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 34.421,
    height: 34.421,
    transform: "translate(-10.667 10.667) rotate(-45)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(15.791 10.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 34.231,
    height: 34.231,
    transform: "translate(-10.533 10.533) rotate(-45)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(15.791 38.259)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M91.3,155.3,67.5,168.825c-1.33.764-2.513.714-3.276.025l-.123.123.123.123c.764.69,1.946.739,3.276-.025l23.945-13.623Z",
    transform: "translate(-64.1 -155.3)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(15.027 49.345)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M61.764,202.616A3.3,3.3,0,0,1,61,200.3v.246a3.274,3.274,0,0,0,.764,2.316l.123-.123Z",
    transform: "translate(-61 -200.3)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(42.988 31.484)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M182.679,129.919l-8.179,4.656.148.148,8.031-4.558A2.888,2.888,0,0,0,184.4,127.8a3.094,3.094,0,0,1-1.724,2.119",
    transform: "translate(-174.5 -127.8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(15.027 10.385)",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M65.163,42.953,97.14,61.109a3.094,3.094,0,0,1,1.724,2.119,2.84,2.84,0,0,0-1.724-2.365L65.163,42.707C62.872,41.4,61,42.485,61,45.121v.246c0-2.636,1.872-3.72,4.163-2.414",
    transform: "translate(-61 -42.153)",
    fill: "#fff"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidButton);
export default __webpack_public_path__ + "static/media/androidButton.c992e4362a696e0647eec6d760edf805.svg";
export { ForwardRef as ReactComponent };